export default __webpack_public_path__ + "static/media/8.b5d4c9b5.jpg";